import styles from './ForceCompleteModal.module.css';

import useAlert from 'hooks/useAlert';
import { observer } from 'mobx-react-lite';
import { FormProvider, useForm } from 'react-hook-form';
import FormTextArea from 'ui/formItems/FormTextArea';
import Modal from 'ui/Modal';
import { productionStore } from 'store/mobx/production.store';
import { useEffect } from 'react';

const ForceCompleteModal = observer(({ setOpen, open }) => {
  const formContext = useForm();
  const { showAlert } = useAlert();
  const { selectedProductionData, forceCompleteIteration } = productionStore;
  const { handleSubmit, reset } = formContext;

  useEffect(() => {
    if (open) {
      reset({ description: '' });
    }
  }, [open, reset]);

  const closeModal = () => setOpen(false);

  const onSubmit = async (data) => {
    sureForceCompleteAlert(async () => {
      const result = await forceCompleteIteration(selectedProductionData.id, data);
      if (result?.status) {
        successForceCompleteAlert();
      } else if (result.code) {
        errorCommonAlert(result.code, result.message);
      }
    });
    closeModal();
  };

  const errorCommonAlert = (code, message) =>
    showAlert(` Код № ${code}${message ? ` - ${message}` : ''}!`, 'error');

  const successForceCompleteAlert = () => showAlert(`Цикл остановлен!`, 'success');

  const sureForceCompleteAlert = (callback) =>
    showAlert('Вы действительно хотите принудительно завершить цикл?', 'sure', callback);

  return (
    <Modal
      title="Принудительное завершение цикла"
      onClose={closeModal}
      onSubmit={handleSubmit(onSubmit)}
      open={open}
      submitText="Завершить"
    >
      <FormProvider {...formContext}>
        <FormTextArea
          label="Описание"
          className={styles.textAreaField}
          name="description"
          placeholder="Опишите причину завершения..."
          required
        />
      </FormProvider>
    </Modal>
  );
});

export default ForceCompleteModal;
